import { render, staticRenderFns } from "./employee-wage.component.vue?vue&type=template&id=292dbf8f&scoped=true&"
import script from "./employee-wage.component.vue?vue&type=script&lang=ts&"
export * from "./employee-wage.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-wage.component.vue?vue&type=style&index=0&id=292dbf8f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292dbf8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VRow,VTab,VTabItem,VTabs,VTabsItems})
